import React, { FC } from 'react'

import { Link } from 'react-router-dom'

import { AppIcon } from '@app/components/AppIcon'
import { PAGE_DASHBOARD } from '@app/constants/navigation'
import { useTypedSelector } from '@app/hooks/useTypedSelector'
import SidebarAlerts from '@app/pages/Dashboard/SideBar/StaticMenu/StaticMenuItems/SidebarAlerts/SidebarAlerts'
import SidebarOrgSettings from '@app/pages/Dashboard/SideBar/StaticMenu/StaticMenuItems/SidebarOrgSettings/SidebarOrgSettings'
import SidebarChatMessages from '@app/pages/Dashboard/SideBar/StaticMenu/StaticMenuItems/SidebarChatMessages/SidebarChatMessages'
import SidebarRecentViewPopover from '@app/pages/Dashboard/SideBar/StaticMenu/StaticMenuItems/SidebarRecentView/SidebarRecentViewPopover'

import { StaticMenuBox } from './styled'
import { selectIsOrgOrSystemAdmin } from '@app/store/reducers/user/selectors'
import SidebarUserActions from '@app/pages/Dashboard/SideBar/StaticMenu/StaticMenuItems/SidebarUserActions/SidebarUserActions'

const StaticMenu: FC = () => {
	const isOrganisationAdmin = useTypedSelector(selectIsOrgOrSystemAdmin)

	return (
		<StaticMenuBox>
			<Link to={PAGE_DASHBOARD}>
				<AppIcon type={'logoSide'} width={61} height={71} />
			</Link>

			<SidebarRecentViewPopover />

			<SidebarAlerts />

			<SidebarChatMessages />

			{isOrganisationAdmin && <SidebarOrgSettings />}

			<SidebarUserActions />
		</StaticMenuBox>
	)
}

export default StaticMenu
